/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Analyze_HintInputs */

const en_keyword_optimizer_analyze_hint = /** @type {(inputs: Keyword_Optimizer_Analyze_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free — no credits used`)
};

const de_keyword_optimizer_analyze_hint = /** @type {(inputs: Keyword_Optimizer_Analyze_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos — kein Guthaben nötig`)
};

const fr_keyword_optimizer_analyze_hint = /** @type {(inputs: Keyword_Optimizer_Analyze_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit — aucun crédit utilisé`)
};

const es_keyword_optimizer_analyze_hint = /** @type {(inputs: Keyword_Optimizer_Analyze_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis — no consume créditos`)
};

const it_keyword_optimizer_analyze_hint = /** @type {(inputs: Keyword_Optimizer_Analyze_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuito — nessun credito usato`)
};

const nl_keyword_optimizer_analyze_hint = /** @type {(inputs: Keyword_Optimizer_Analyze_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis — geen credits gebruikt`)
};

const pl_keyword_optimizer_analyze_hint = /** @type {(inputs: Keyword_Optimizer_Analyze_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezpłatnie — bez zużycia kredytów`)
};

const fi_keyword_optimizer_analyze_hint = /** @type {(inputs: Keyword_Optimizer_Analyze_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen — ei käytä krediittejä`)
};

const da_keyword_optimizer_analyze_hint = /** @type {(inputs: Keyword_Optimizer_Analyze_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis — ingen credits brugt`)
};

const sv_keyword_optimizer_analyze_hint = /** @type {(inputs: Keyword_Optimizer_Analyze_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis — inga credits används`)
};

/**
* | output |
* | --- |
* | "Free — no credits used" |
*
* @param {Keyword_Optimizer_Analyze_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_analyze_hint = /** @type {((inputs?: Keyword_Optimizer_Analyze_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Analyze_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_analyze_hint(inputs)
	if (locale === "fr") return fr_keyword_optimizer_analyze_hint(inputs)
	if (locale === "es") return es_keyword_optimizer_analyze_hint(inputs)
	if (locale === "it") return it_keyword_optimizer_analyze_hint(inputs)
	if (locale === "nl") return nl_keyword_optimizer_analyze_hint(inputs)
	if (locale === "pl") return pl_keyword_optimizer_analyze_hint(inputs)
	if (locale === "fi") return fi_keyword_optimizer_analyze_hint(inputs)
	if (locale === "da") return da_keyword_optimizer_analyze_hint(inputs)
	if (locale === "sv") return sv_keyword_optimizer_analyze_hint(inputs)
	return en_keyword_optimizer_analyze_hint(inputs)
});